import { Box } from '@mui/material';
import logo from '@assets/img/logo.svg';

interface LoadingProps {
    size?: number;
}

function Loading({ size = 160 }: LoadingProps): JSX.Element {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                p: 5,
                animation: 'fadeInOut 2s infinite',
            }}
        >
            <img width={size} src={logo} alt="loading" />
        </Box>
    );
}

export default Loading;
